import React, { useState, useEffect, useContext } from 'react';
import { MenuItem, Select, styled } from '@nextiva/next-ui-components';
import { EmailContext, actionTypes } from 'containers/pages/Email/emailContext';

const StyledSelect = styled(Select)`
  float: ${({ actionsOpen }) => actionsOpen && 'right'};
  width: ${({ actionsOpen }) => actionsOpen && '100%'};
  & .MuiSelect-select span {
    color: ${({ theme }) => theme.palette.blueGrey.A400};
  }
`;

const StyledMenuItem = styled(MenuItem)`
  font-size: 14px;
  color: ${({ label }) => label === 'Remove Domain' && '#da3444 !important'};
  white-space: ${({ label }) => label === 'Authenticate domain' && 'nowrap'};
  &:hover {
    font-weight: 700;
  }
  padding-right: ${({ label }) => label === 'Remove Domain' && '10px'};
  div.MuiPaper-root {
    left: 84vw;
  }
`;

const linksConst = {
  RESEND_VERIFICATION: 'resendVerification',
  AUTHENTICATE_DOMAIN: 'authenticateDomain',
  REMOVE_DOMAIN: 'removeDomain',
};

export const DomainActions = ({
  domain,
  status,
  toggleModal,
  toggleDrawer,
}) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [actionsOpen, setActionsOpen] = useState(false);
  const { dispatch } = useContext(EmailContext);

  const setSelectedDomain = (domain) => {
    dispatch({
      type: actionTypes.SELECT_DOMAIN,
      selectedDomain: domain,
    });
  };

  const setDomainForRemoval = (domain) => {
    setSelectedDomain(domain);
    setSelectedOption('');
    toggleModal();
  };

  const setDomainForAuthentication = (domain) => {
    setSelectedDomain(domain);
    setSelectedOption('');
    toggleDrawer();
  };
  // Status: "Pending Verification" - Actions: [Resend Verification, Remove domain]
  const optionsPending = [
    {
      label: 'Remove Domain',
      value: linksConst.REMOVE_DOMAIN,
    },
  ];

  // Status: "Verified"- Actions: [Authenticate domain, Remove domain]
  const optionsVerified = [
    {
      label: 'Authenticate domain',
      value: linksConst.AUTHENTICATE_DOMAIN,
    },
    {
      label: 'Remove Domain',
      value: linksConst.REMOVE_DOMAIN,
    },
  ];

  // Status: "Authenticated" - Actions: [Remove domain]
  const optionsAuthenticated = [
    {
      label: 'Remove Domain',
      value: linksConst.REMOVE_DOMAIN,
    },
  ];

  const handleSelectChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const determineOptions = (_status) => {
    if (_status === 'Authenticated') {
      return optionsAuthenticated;
    } else if (_status === 'Verified') {
      return optionsVerified;
    }

    return optionsPending;
  };

  useEffect(() => {
    switch (selectedOption) {
      case linksConst.RESEND_VERIFICATION:
        // resendVerification(domain);
        break;
      case linksConst.AUTHENTICATE_DOMAIN:
        setDomainForAuthentication(domain);
        break;
      case linksConst.REMOVE_DOMAIN:
        setDomainForRemoval(domain);
        break;
      default:
        break;
    }
  }, [selectedOption]);
  return (
    <StyledSelect
      id="selectID"
      placeholder="Actions"
      value={selectedOption}
      onChange={handleSelectChange}
      onOpen={() => setActionsOpen(true)}
      onClose={() => setActionsOpen(false)}
      actionsOpen={actionsOpen}
      data-testid="PlatformAdminUI-DomainActions-Select"
    >
      {determineOptions(status).map((option) => (
        <StyledMenuItem
          key={option.value}
          value={option.value}
          label={option.label}
        >
          {option.label}
        </StyledMenuItem>
      ))}
    </StyledSelect>
  );
};
